import { render, staticRenderFns } from "./PickerCard.vue?vue&type=template&id=190cf73c&scoped=true&"
import script from "./PickerCard.ts?vue&type=script&lang=ts&"
export * from "./PickerCard.ts?vue&type=script&lang=ts&"
import style0 from "./PickerCard.vue?vue&type=style&index=0&id=190cf73c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190cf73c",
  null
  
)

export default component.exports